document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.tab');
    const tabsContent = document.querySelectorAll('.content-tab');

    tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            tabs.forEach(tab => tab.classList.remove('active'));
            tabsContent.forEach(tabContent => tabContent.classList.remove('active'));

            tabsContent.forEach(tabContent => {
                if (tabContent.dataset.value === tab.dataset.name) {
                    tab.classList.add('active');
                    tabContent.classList.add('active');
                }
            });
        });
    });
});